import { CellProps } from 'react-table'
import { TFunction } from '../../../../../../../_metronic/i18n/Metronici18n'
import {
  DataColumn,
  PlainHeader,
  sortableColumn,
  StackedCell,
  StatusDot,
  StatusDotTone,
  TableColumn,
} from '../../../../../../components'
import { NotaVersaoList, SituacaoPublicacao, situacaoPublicacao } from '../../../core/_models'
import { useQueryRequest } from '../../../core/QueryRequestProvider'
import { NotasVersaoActionsCell } from './NotasVersaoActionsCell'

const TOM_SITUACAO: Record<SituacaoPublicacao, StatusDotTone> = {
  RASCUNHO: 'neutral',
  AGENDADA: 'info',
  PUBLICADA: 'success',
}

export const notasVersaoColumns = (t: TFunction): ReadonlyArray<TableColumn<NotaVersaoList>> => [
  sortableColumn<NotaVersaoList>({
    id: 'titulo',
    useQueryRequest,
    fields: [
      { field: 'titulo', label: t('notas_versao.col.titulo') },
      { field: 'versao', label: t('notas_versao.col.versao') },
    ],
    Cell: ({ row }: CellProps<NotaVersaoList>) => (
      <StackedCell
        primary={row.original.titulo}
        secondary={t('notas_versao.versao_x', { versao: row.original.versao })}
      />
    ),
  }),
  sortableColumn<NotaVersaoList>({
    id: 'dtPublicacao',
    cellWidth: '160px',
    useQueryRequest,
    fields: [{ field: 'dtPublicacao', label: t('notas_versao.col.publicacao') }],
    Cell: ({ row }: CellProps<NotaVersaoList>) => <DataColumn data={row.original.dtPublicacao} />,
  }),
  {
    Header: () => <PlainHeader>{t('notas_versao.col.situacao')}</PlainHeader>,
    id: 'situacao',
    cellWidth: '140px',
    Cell: ({ row }: CellProps<NotaVersaoList>) => {
      const situacao = situacaoPublicacao(row.original, new Date())
      return (
        <StatusDot label={t(`notas_versao.situacao.${situacao}`)} tone={TOM_SITUACAO[situacao]} />
      )
    },
  },
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '96px',
    align: 'end',
    Cell: ({ row }: CellProps<NotaVersaoList>) => <NotasVersaoActionsCell nota={row.original} />,
  },
]
